export const lockBodyScroll = () => {
  if (!document) return;
  document.body.style.overflow = 'hidden';
  document.body.style.position = 'fixed';
  document.body.style.width = '100%';
};

export const unlockBodyScroll = () => {
  if (!document) return;
  document.body.style.overflow = '';
  document.body.style.position = '';
  document.body.style.width = '';
};

export const lockBodyScrollClass = () => {
  document?.body.classList.add('body-lock');
};

export const unlockBodyScrollClass = () => {
  document?.body.classList.remove('body-lock');
};
